<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
    <div class="row">
      <div [hidden]="pageLoader">
        <div class="adjust loader-container">
          <div class="loader2"></div>
        </div>
      </div>
      <div class="col-md-12" [hidden]="!pageLoader">
        <div class="page-breadcrumb">
          <ul class="page-breadcrumb__trail">
            <li><a>Manage</a></li>
            <li><a>Infra Setup</a></li>
            <li><a>Businesses</a></li>
            <li><a>Account Closure</a></li>
          </ul>
          <div class="page-breadcrumb__icons">
            <a routerLink="/home/businesses"><img src="../../../../assets/images/New_Icons/back-transprent-icon.svg" title="Back"></a>
          </div>
        </div>
        <div class="block">
          <div class="screen_heading_div">
            <span>Account Closure</span>
          </div>
          <div class="Reports_form_div">
            <div class="requested_details" *ngIf="businessEntity.accountStatus != 'active'">
              <span *ngIf="businessEntity.accountStatus == 'markedForInactivation'"><span class="account-status">Closure</span>&nbsp;request raised by <span class="account-status">{{requestedPersonName || ''}}</span> on <span class="account-status">{{((requestedDateTime ? requestedDateTime.split('T')[0] : '') | date:"dd MMM yyyy")}} {{convertTo24Hrs(requestedDateTime || '')}}</span></span>
              <span *ngIf="businessEntity.accountStatus == 'inactivated'">Account <span class="account-status">De-activated</span> by <span class="account-status">{{requestedPersonName || ''}}</span> on <span class="account-status">{{((requestedDateTime ? requestedDateTime.split('T')[0] : '') | date:"dd MMM yyyy")}} {{convertTo24Hrs(requestedDateTime || '')}}</span></span>
              <span *ngIf="businessEntity.accountStatus == 'closed'">Account <span class="account-status">Closed</span>&nbsp; by <span class="account-status">{{requestedPersonName || ''}}</span> on <span class="account-status">{{((requestedDateTime ? requestedDateTime.split('T')[0] : '') | date:"dd MMM yyyy")}} {{convertTo24Hrs(requestedDateTime || '')}}</span></span>
            </div>
            <div class="business_info_details">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 business-info">
                   <div class="col-lg-6 col-md-6 col-sm-6">
                      <span class="headings">Business Name</span>
                      <span class="names">{{businessEntity.businessName}}</span>
                   </div>
                   <div class="col-lg-6 col-md-6 col-sm-6">
                      <span class="headings">Owner Name</span>
                      <span class="names">{{businessOwnerName || '--'}}</span>
                   </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 business-onboard">
                  <div class="col-lg-5 col-md-5 col-sm-5">
                    <span class="headings">On Boarded Date</span>
                    <span class="names">{{businessEntity.createdAt | date:"dd MMM yyyy"}}</span>
                 </div>
                   <div class="col-lg-7 col-md-7 col-sm-7">
                      <span class="headings">Operating Since</span>
                      <span class="names">{{operatingSinceDays}}</span>
                   </div>
                </div>
              </div>
            </div>
            <div class="status_updates">
              <div>
                <input type="radio" id="cancelRequest" name="accountStatus" [(ngModel)]="selectedOption" value="cancel" [disabled]="!activateAccount">
                <label for="cancelRequest">Cancel request / Re-activate account</label>
              </div>
              <div>
                <input type="radio" id="deactivateAccount" name="accountStatus" [(ngModel)]="selectedOption" value="inactivate" [disabled]="!inactivateAccount">
                <label for="deactivateAccount">De-activate account</label>
              </div>
              <div>
                <input type="radio" id="closeAccount" name="accountStatus" [(ngModel)]="selectedOption" value="close" [disabled]="!closeAccount">
                <label for="closeAccount">Close account</label>
              </div>
            </div>        
            <div class="row">
              <div class="buttons-div">
                <div class="transactions-button-container" (click)="confirmationAlert()">
                  <button class="transaction-close-button" [disabled]="selectedOption == undefined">
                    <span class="icon"><img src="../../../../../assets/images/New_Icons/tick-icon.svg"></span>
                    <span class="text">Submit</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Account Closure request or closure request cancel or reactivation request dialog confirmation alert start -->
        <div class="modal fade" id="notification" role="dialog">
          <div class="modal-dialog modal-lg notificationdiv">
            <div class="modal-content notification-modal" style="border-width: none;">
              <div class="modal-body" style="position:relative">
                <div class="message-content">
                  <div><span><img src="../../../../../../../assets/images/New_Icons/alert-danger-without-fill.svg" width="50px" height="50px"></span></div>
                  <div>
                    <span class="notification-main-messsage">{{message}}</span><br>
                    <span class="notification-sub-messsage">{{subMessage}}</span>
                  </div>
                </div>
                <div style="text-align: right;margin-top: 3rem;">
                  <button class="modal-btn registerbtn" (click)="submitButtonName == 'No' ? onCancelingTheRequest() : onSubmittingTheRequest()" [disabled]="requestBtnEnableDisable" [ngClass]="{ 'dynamicBackgroundClass': submitButtonName == 'Yes' }">{{submitButtonName}}</button>
                  <button class="modal-btn skipbtn" (click)="cancelButtonName == 'Yes' ? onSubmittingTheRequest() : onCancelingTheRequest()" [disabled]="cancelBtnEnableDisable" [ngClass]="{ 'dynamicBackgroundCancelClass': cancelButtonName == 'No' }">{{cancelButtonName}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Account Closure request or closure request cancel or reactivation request dialog confirmation alert end -->

        <!-- Account Closure request or closure request cancel or reactivation request dialog sucessfull alert start -->
        <div class="modal fade" id="sucessNotification" role="dialog">
          <div class="modal-dialog modal-lg notificationdiv">
            <div class="modal-content notification-modal" style="border-width: none;">
              <div class="modal-body" style="position:relative">
                <div class="sucessfull-message-content">
                  <div><span><img src="../../../../../../../assets/images/New_Icons/approve icon.svg" width="40px" height="40px"></span></div>
                  <div><span class="sucess-messsage">{{sucessMessage}}</span></div>
                </div>
                <div style="text-align: center;margin-top: 3rem;">
                  <button class="modal-btn skipbtn" (click)="onCloseSucessfullPopup()">Ok</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Account Closure request or closure request cancel or reactivation request dialog sucessfull alert end -->
      </div>
    </div>
  </div>
